import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/projects/$id/resources/")({
  staticData: {
    title: "common.resources",
  },
});
